<template>

    <section class="list">
        <div class="card">
            <div class="card-header">
                <span>{{ $t('List Group FQA') }}</span>
                <div class="card-actions">
                    <a style="cursor: pointer" v-permission="$permissions.CREATE_GROUP_FAQ" @click="create()"
                        v-b-tooltip.hover :title="$t('group-faq.create')">
                        <small class="text-muted">
                            <i class="fa fa-plus-square action-icon" style="font-size: 18px;"></i></small>
                    </a>
                </div>
            </div>
            <div class="card-body p-1">
                <div class="table-responsive">
                    <div class="mb-0 table-outline table-responsive-sm">
                        <table aria-busy="false" aria-colcount="6" class="table b-table table-hover">
                            <thead class="thead-light">
                                <tr>
                                    <th>{{ $t('group-faq.attribute.name') }}</th>
                                    <th>{{ $t('group-faq.attribute.description') }}</th>
                                    <th>{{ $t('group-faq.attribute.count') }}</th>
                                    <th>{{ $t('common.status') }}</th>
                                    <th>{{ $t('group-faq.attribute.action') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(faq, key) in group_faqs" :key="key">
                                    <td>{{ faq.name }}</td>
                                    <td>{{ faq.desc ? faq.desc : faq.name }}</td>
                                    <td>{{ faq.count }}</td>
                                    <td>
                                        <status :status.sync="faq.status" :options.sync="options"
                                            @approval="approval(faq)" @rejection="rejection(faq)" />
                                    </td>
                                    <td>
                                        <b-dropdown variant="link" size="md" no-caret>
                                            <template slot="button-content">
                                                <i class="fa fa-bars"></i>
                                            </template>
                                            <b-dropdown-item @click="edit(faq)"><i
                                                    class="fa fa-edit"></i>{{ $t('document.attribute.edit') }}</b-dropdown-item>
                                            <b-dropdown-item @click="destroy(faq)"><i
                                                    class="fa fa-remove"></i>{{ $t('document.attribute.delete') }}</b-dropdown-item>
                                        </b-dropdown>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="pt-3">
                        <select name="total_user" v-model='per_page' required="required" @change="changeTotal">
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                        </select>
                        trên tổng {{ total }} bản ghi
                        <paginate :page-count="last_page" :click-handler="changePage" :prev-text="'Prev'"
                            :next-text="'Next'" :container-class="'pagination'" class="pull-right">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
        <Create ref="create" @createSuccess="createSuccess"></Create>
        <Update ref="update" @updateSuccess="updateSuccess"></Update>
    </section>
</template>
<script>
import { mapGetters } from 'vuex'
import Paginate from 'vuejs-paginate'
import Status from '@/components/status'
import swal from 'sweetalert'
import Create from './create'
import Update from './update'

export default {
  name: 'list',
  components: { Paginate, Status, Create, Update },
  props: [],
  data () {
    return {
      per_page: 100,
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      group_faqs: 'GroupFAQ/getListGroupFAQ',
      last_page: 'GroupFAQ/getLastPage',
      total: 'GroupFAQ/getTotal',
      options: 'Status/getStatusCheckerMaker'
    })
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', { page: this.page, per_page: this.per_page }),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {

    }).catch(errors => {

    })
  },
  methods: {
    changeTotal () {
      Promise.all([
        this.$store.dispatch('GroupFAQ/getListGroupFAQ', { page: this.page, per_page: this.per_page })
      ]).then(res => {

      }).catch(errors => {

      })
    },
    changePage (page) {
      this.page = page

      Promise.all([
        this.$store.dispatch('GroupFAQ/getListGroupFAQ', { page: this.page, per_page: this.per_page })
      ]).then(res => {

      }).catch(errors => {

      })
    },
    approval (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/approvalGroupFAQ', { group_faq }).then(res => {
        group_faq.status = res.status

        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {

      })
    },
    rejection (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/rejectGroupFAQ', { group_faq }).then(res => {
        group_faq.status = res.status

        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {

      })
    },
    destroy (group_faq = {}) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$store.dispatch('GroupFAQ/destroyGroupFAQ', {
              group_faq
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$store.dispatch('GroupFAQ/getListGroupFAQ', { page: this.page, per_page: this.per_page })
            }).catch(errors => {

            })
          }
        })
    },
    create () {
      this.$refs.create.show()
    },
    edit (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/showGroupFAQ', { group_faq }).then(res => {
        this.$refs.update.show(res)
      }).catch(errors => {

      })
    },
    createSuccess (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', { page: this.page, per_page: this.per_page }).then(res => {
        this.$refs.create.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
      })
    },
    updateSuccess (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', { page: this.page, per_page: this.per_page }).then(res => {
        this.$refs.update.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      })
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/group-faq/list.vue